import type { ReactElement } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AdminLayout } from "./components/AdminLayout";
import { LoginScreen } from "./screens/LoginScreen";
import { PlansScreen } from "./screens/PlansScreen";
import { PromoCodesScreen } from "./screens/PromoCodesScreen";
import { SettingsScreen } from "./screens/SettingsScreen";
import { StatsScreen } from "./screens/StatsScreen";
import { UserCardScreen } from "./screens/UserCardScreen";
import { UsersScreen } from "./screens/UsersScreen";
import { useAuthStore } from "./store/authStore";

function ProtectedRoute({ children }: { children: ReactElement }) {
  const token = useAuthStore((state) => state.token);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* «Пользователи» — первый готовый раздел (Этап 6), поэтому по умолчанию сразу на
              него, не на отдельную пустую домашнюю страницу. Раздел 6 добавит свой Route рядом,
              когда появится (см. docs/PLAN.md). */}
          <Route index element={<Navigate to="/users" replace />} />
          <Route path="users" element={<UsersScreen />} />
          <Route path="users/:userId" element={<UserCardScreen />} />
          <Route path="plans" element={<PlansScreen />} />
          <Route path="promo-codes" element={<PromoCodesScreen />} />
          <Route path="settings" element={<SettingsScreen />} />
          <Route path="stats" element={<StatsScreen />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
